import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as httpUtil from "@/utils/httpUtil";
const interfaces = [{
  method: "post",
  name: "shopDetail",
  url: "/c/pc/community/shop/detail",
  desc: "详情"
}, {
  method: "post",
  name: "shopSave",
  url: "/c/pc/community/shop/save",
  desc: "新增/修改"
}];
function exportsRender(interfacesArr) {
  const resultExports = {};
  interfacesArr.map(item => {
    resultExports[item.name] = data => {
      return httpUtil[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}
export default exportsRender(interfaces);